<template>
  <div>
    <v-skeleton-loader
      v-for="skeleton of count"
      :key="skeleton"
      boilerplate
      v-bind="$attrs"
      class="py-3 flex-grow-1"
    />
  </div>
</template>
<script setup lang="ts">
import { defineProps, ref } from 'vue'

const props = defineProps<{
  count?: number
}>()
</script>
